
// src/components/Contact.js

import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Grid,
  Typography,
  Box
} from "@mui/material";

import axios from "axios";
import BASE_URL from "../config";
import { footerConfigs } from "../components/footerConfigs";

const Contact = () => {

  // Current school configuration
  const school = footerConfigs.bheema;

  // Default Google Map
  const defaultGoogleMap =
    "https://www.google.com/maps";

  // Use configured map if available.
  // Otherwise use default map.
  const googleMapUrl =
    school.googleMap && school.googleMap.trim() !==""
      ? school.googleMap
      : defaultGoogleMap;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: ""
  });

  const [errors, setErrors] = useState({});

  const validate = () => {

    let tempErrors = {};

    tempErrors.name = formData.name
      ? ""
      : "Name is required.";

    tempErrors.email =
      /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(formData.email)
        ? ""
        : "Email is not valid.";

    tempErrors.mobile =
      /^\d{10}$/.test(formData.mobile)
        ? ""
        : "Mobile number should be 10 digits.";

    tempErrors.message = formData.message
      ? ""
      : "Message is required.";

    setErrors(tempErrors);

    return Object.values(tempErrors).every(
      (x) => x === ""
    );
  };

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {

      await axios.post(
        `${BASE_URL}/api/inquiries`,
        formData
      );

      console.log(
        "Form submitted",
        formData
      );

      setFormData({
        name: "",
        email: "",
        mobile: "",
        message: ""
      });

      alert(
        "Inquiry submitted successfully!"
      );

    } catch (error) {

      console.error(
        "Error submitting form",
        error
      );

      alert(
        "Unable to submit inquiry."
      );
    }
  };

  return (

    <Container maxWidth="lg">

      <Typography
        variant="h4"
        sx={{ mt: 4, mb: 3 }}
      >
        Contact Us
      </Typography>

      {/* Contact Form */}

      <Box
        component="form"
        onSubmit={handleSubmit}
      >

        <Grid
          container
          spacing={2}
        >

          <Grid item xs={12} md={6}>

            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.name}
              helperText={errors.name}
            />

          </Grid>

          <Grid item xs={12} md={6}>

            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.email}
              helperText={errors.email}
            />

          </Grid>

          <Grid item xs={12} md={6}>

            <TextField
              label="Mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.mobile}
              helperText={errors.mobile}
              inputProps={{
                maxLength: 10
              }}
            />

          </Grid>

          <Grid item xs={12}>

            <TextField
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              fullWidth
              required
              multiline
              rows={4}
              error={!!errors.message}
              helperText={errors.message}
            />

          </Grid>

          <Grid item xs={12}>

            <Button
              type="submit"
              variant="contained"
            >
              Submit
            </Button>

          </Grid>

        </Grid>

      </Box>

      {/* School Details */}

      <Box sx={{ mt: 5 }}>

        <Typography
          variant="h6"
          sx={{ mb: 1 }}
        >
          Our Address
        </Typography>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            mb: 1
          }}
        >
          {school.brandName || "School Name"}
        </Typography>

        <Typography
          variant="body1"
          sx={{ mb: 2 }}
        >
          {school.address || "School address not provided"}
        </Typography>

        {/* Google Map */}

        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            borderRadius: 2
          }}
        >

          <iframe
            src={googleMapUrl}
            width="100%"
            height="300"
            style={{
              border: 0,
              marginTop: 16
            }}
            allowFullScreen=""
            loading="lazy"
            title="School Google Map"
          />

        </Box>

      </Box>

    </Container>

  );
};

export default Contact;

